import { BodyMeasurementQueries } from './queries';
import { BodyMeasurementMutations } from './mutations';

export const BodyMeasurement = {
  queries: BodyMeasurementQueries,
  mutations: BodyMeasurementMutations,
};

export * from './types';
